import { createFileRoute } from '@tanstack/react-router';
import CollateralClauseView from '../../../features/baseData/collateralClauses/collateralClause/view';
import {
  COLLATERAL_CLAUSES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/nebenbestimmungen/$collateralClauseId',
)({
  component: CollateralClauseView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COLLATERAL_CLAUSES_PERMISSIONS, 'READ'),
  ),
});

export const ViewCollateralClauseRoute = Route;
